import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { Slider } from '../components/slider/Slider';
import { ContentTile } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { isNullOrUndefined } from '@as-react/common-utils';
const SLIDES_TO_SCROLL = 1;
const sliderConfig = {
    displayCroppedSlides: false,
    hideOnViewports: false,
    infiniteSliding: false,
    innerSpacing: true,
    showArrowsForDesktop: true,
    showIndicators: false,
    slidesToScrollMobile: SLIDES_TO_SCROLL,
    slidesToScrollMobileLarge: SLIDES_TO_SCROLL,
    slidesToScrollTabletSmall: SLIDES_TO_SCROLL,
    slidesToScrollTablet: SLIDES_TO_SCROLL,
    slidesToScrollDesktop: SLIDES_TO_SCROLL,
    slidesToScrollDesktopLarge: SLIDES_TO_SCROLL,
    slidesToShowMobile: 1.25,
    slidesToShowMobileLarge: 1.25,
    slidesToShowTabletSmall: 3.25,
    slidesToShowTablet: 3.25,
    slidesToShowDesktop: 3.8,
    slidesToShowDesktopLarge: 3.8,
};
const AuthorLinkedContentPagesContainer = (data) => {
    var _a;
    const { t } = useTranslation([I18N_NAMESPACES.general]);
    const contentTileTranslations = {
        readMore: t(`${I18N_NAMESPACES.general}:readMore`),
    };
    if (!(((_a = data === null || data === void 0 ? void 0 : data.contentDetailPages) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: { base: '10', md: '12', xl: '16' }, children: _jsxs(StackBlock, { gap: '6', children: [(data === null || data === void 0 ? void 0 : data.name) && (_jsx(TextAlpha, { color: 'emphasised', variant: 'headingS', as: "h2", children: t('author.page.articles.title', {
                        name: data.name,
                    }) })), _jsx(Slider, { properties: sliderConfig, id: 'author-articles-slider', children: data.contentDetailPages.map((slide, index) => (_jsx("div", { children: _jsx(ContentTile, { href: slide.url || '/', title: slide.title || '', text: slide.shortDescription || '', tags: slide.tags || [], translations: contentTileTranslations, image: isNullOrUndefined(slide.image.imagePath)
                                ? { src: '' }
                                : {
                                    src: slide.image.imagePath,
                                    isPicture: true,
                                    lazy: true,
                                }, withoutSpacing: true }) }, `slide_component_${index}}`))) })] }) }));
};
export default AuthorLinkedContentPagesContainer;
